
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.807 7.066a2.533 2.533 0 01-1.086-.443 2.705 2.705 0 01-.796-.898 2.902 2.902 0 01-.178-2.39c.09-.254.104-.53.038-.791a1.305 1.305 0 00-.405-.667A9.723 9.723 0 0013.447.082a1.171 1.171 0 00-.76-.035c-.25.074-.472.229-.634.443a2.64 2.64 0 01-.91.779 2.493 2.493 0 01-2.285 0 2.64 2.64 0 01-.911-.78 1.23 1.23 0 00-.634-.442 1.171 1.171 0 00-.76.035C5.566.464 4.643 1.01 3.82 1.7a1.317 1.317 0 00-.427.683c-.07.27-.055.556.04.817a2.886 2.886 0 01-.183 2.463c-.21.367-.5.677-.844.904a2.509 2.509 0 01-1.14.406c-.262.03-.509.148-.703.337a1.323 1.323 0 00-.376.713 10.635 10.635 0 00-.06 3.626c.042.282.172.542.368.74.196.197.449.32.718.35.414.042.812.187 1.161.424.35.237.64.558.848.938a2.88 2.88 0 01.111 2.518c-.113.26-.141.552-.08.83.062.278.21.526.42.705a9.792 9.792 0 002.907 1.768 1.176 1.176 0 00.983-.069A1.25 1.25 0 008 19.45c.238-.366.556-.665.928-.87a2.47 2.47 0 012.377-.018c.363.193.679.473.922.817.161.23.39.396.65.474.26.078.538.062.79-.044a9.906 9.906 0 002.666-1.683c.201-.175.345-.414.41-.68a1.371 1.371 0 00-.05-.805 2.884 2.884 0 01.147-2.448 2.69 2.69 0 01.82-.915c.336-.234.72-.382 1.12-.432.26-.038.5-.162.689-.355.188-.192.313-.443.358-.716.107-.587.165-1.183.173-1.781 0-.63-.056-1.26-.167-1.88a1.312 1.312 0 00-.352-.7 1.196 1.196 0 00-.674-.349zm-5.474 2.929c0 .696-.195 1.377-.561 1.956a3.38 3.38 0 01-1.496 1.296c-.61.267-1.28.337-1.926.2a3.283 3.283 0 01-1.707-.963 3.585 3.585 0 01-.912-1.802 3.704 3.704 0 01.19-2.034 3.486 3.486 0 011.227-1.58A3.209 3.209 0 0110 6.475c.884 0 1.732.37 2.357 1.03.625.66.976 1.556.976 2.49z","fill":"#E2E8F0"}})])
          )
        }
      }
    